var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["footer/sticky-email-signup.j2"] = require( "footer/sticky-email-signup.j2" );
dependencies["footer/email-initializer.j2"] = require( "footer/email-initializer.j2" );
dependencies["footer/store-locator.j2"] = require( "footer/store-locator.j2" );
dependencies["footer/navigation.j2"] = require( "footer/navigation.j2" );
dependencies["footer/footer-social-header.j2"] = require( "footer/footer-social-header.j2" );
dependencies["footer/tertiary-content.j2"] = require( "footer/tertiary-content.j2" );
dependencies["footer/social.j2"] = require( "footer/social.j2" );
dependencies["promo-rotational-banner.j2"] = require( "promo-rotational-banner.j2" );
dependencies["footer/language-links.j2"] = require( "footer/language-links.j2" );
dependencies["footer/privacy-links.j2"] = require( "footer/privacy-links.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/core-footer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<footer class=\"dom-footer\" role=\"contentinfo\" data-qa-footer-wrap>\n\n    ";
env.getTemplate("footer/sticky-email-signup.j2", false, "core/templates/footer/core-footer.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n    <div class=\"c-site-footer\">\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavIsInFlatNav")) {
output += "\n            ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation");
frame.set("footerFlatNavigation", t_5, true);
if(frame.topLevel) {
context.setVariable("footerFlatNavigation", t_5);
}
if(frame.topLevel) {
context.addExport("footerFlatNavigation", t_5);
}
output += "\n        ";
;
}
else {
output += "\n            ";
var t_6;
t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerFlatNavigation");
frame.set("footerFlatNavigation", t_6, true);
if(frame.topLevel) {
context.setVariable("footerFlatNavigation", t_6);
}
if(frame.topLevel) {
context.addExport("footerFlatNavigation", t_6);
}
output += "\n        ";
;
}
output += "\n\n\n        <div class=\"o-row c-site-footer__inner\">\n\n            <div class=\"o-row o-column o-extra-small--12 o-medium--3 c-quick-links\">\n\n                <div class=\"o-column o-extra-small--12 o-small--6 o-medium--12 c-quick-links__inner-wrapper\">\n                    ";
env.getTemplate("footer/email-initializer.j2", false, "core/templates/footer/core-footer.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n                </div>\n\n                <div class=\"o-column o-extra-small--12 o-small--6 o-medium--12 c-quick-links__inner-wrapper\">\n                    ";
env.getTemplate("footer/store-locator.j2", false, "core/templates/footer/core-footer.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n                </div>\n\n            </div>\n\n\n            <div class=\"o-row o-column o-extra-small--12 o-medium--9 o-large--6 c-footer-help__inner\">\n\n                ";
env.getTemplate("footer/navigation.j2", false, "core/templates/footer/core-footer.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n            </div>\n\n            <div class=\"o-row o-column o-extra-small--12 o-large--3\">\n\n                <div class=\"o-row c-site-footer__social-section\">\n\n                    <div class=\"o-column o-extra-small--12 o-medium--6 o-large--12\">\n\n                        <div class=\"u-extra-small--hide u-large--show\">\n\n                            ";
env.getTemplate("footer/footer-social-header.j2", false, "core/templates/footer/core-footer.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n                        </div>\n\n                        ";
env.getTemplate("footer/tertiary-content.j2", false, "core/templates/footer/core-footer.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n                    </div>\n\n                    <div class=\"o-column o-extra-small--12 o-medium--6 o-large--12\">\n                        ";
env.getTemplate("footer/social.j2", false, "core/templates/footer/core-footer.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"secondaryFooterPromos")) {
output += "\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12\">\n\n                    <div class=\"c-footer-content-slot u-centered-content\">\n\n                            ";
env.getTemplate("promo-rotational-banner.j2", false, "core/templates/footer/core-footer.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n                    </div>\n\n                </div>\n\n            </div>\n\n        ";
})});
}
output += "\n\n        <div class=\"c-site-footer__utility\">\n\n            <div class=\"o-row c-site-footer__inner\">\n\n                <div class=\"o-column o-extra-small--12 o-medium--4\">\n\n                    ";
env.getTemplate("footer/language-links.j2", false, "core/templates/footer/core-footer.j2", null, function(t_37,t_35) {
if(t_37) { cb(t_37); return; }
t_35.render(context.getVariables(), frame, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
output += t_36
output += "\n\n                </div>\n\n                <div class=\"o-column o-extra-small--12 o-medium--8\">\n\n                    ";
env.getTemplate("footer/privacy-links.j2", false, "core/templates/footer/core-footer.j2", null, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
t_39.render(context.getVariables(), frame, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
output += t_40
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</footer>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/core-footer.j2"] , dependencies)